import apiClient from './apiClient';

export interface PendingShipment {
  fm130_01: string;
  fm130_11: string;
  fm130_12: number;
  fm130_13: string;
  fm130_14: number;
  fm130_16: string;
  fm130_20: string;
  dept_name: string;
  fm130_80: string;
}

export interface QueryResponse {
  items: PendingShipment[];
  total: number;
}

export interface ExecuteResponse {
  results: Array<{ document_key: string; success: boolean; message: string }>;
  success: number;
  failed: number;
  message: string;
}

export const m503Api = {
  async query(startNo: string, endNo: string): Promise<QueryResponse> {
    const response = await apiClient.post('/api/m503/query', {
      start_no: startNo,
      end_no: endNo,
    });
    return response.data;
  },

  async execute(documentKeys: string[]): Promise<ExecuteResponse> {
    const response = await apiClient.post('/api/m503/execute', {
      document_keys: documentKeys,
      confirmed: true,
    });
    return response.data;
  },
};

